import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=217feea0&scoped=true"
import script from "./wxpay.vue?vue&type=script&lang=js"
export * from "./wxpay.vue?vue&type=script&lang=js"
import style0 from "./wxpay.vue?vue&type=style&index=0&id=217feea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217feea0",
  null
  
)

export default component.exports